import { Component, Input } from '@angular/core';
import { Observable, of } from 'rxjs';
import { MediaResponse } from '../../../features/influencer/modules/media/models/media.model';

@Component({
  selector: 'vota-media-list',
  templateUrl: './media-list.component.html',
  styleUrl: './media-list.component.scss',
})
export class MediaListComponent {
  @Input() posts$: Observable<MediaResponse[] | null | undefined> = of([]);
  @Input() preview: boolean = false;
}
